


import { ClientAssessmentVM } from './ClientAssessmentVM';
import { CountryVM } from './CountryVM';
import { Gender } from './Gender';
import { NationalityVM } from './NationalityVM';
export class RegisterVM {

  email?: string;

  password?: string;

  assessment?: ClientAssessmentVM;

  addressLine1?: string;

  addressLine2?: string;

  city?: string;

  county?: string;

  country?: CountryVM;

  state?: string;

  dateOfBirth?: string;

  age?: number;

  displayName?: string;

  firstname?: string;

  gender?: Gender;

  hasProfileImage?: boolean;

  lastname?: string;

  mobile?: string;

  postcode?: string;

  nationality?: NationalityVM;

  timeZone?: string;

}
